import cmd from './cmd/index.js';

// This only exposes cmd, while util/logger and util/adb are defined as
// separate additional exports in the package.json.
export default { cmd };
